import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";

export class Menu extends EntityDto implements IEntityDto {
  Menu_Id: string;
  Menu_Name: string;
  Menu_Parent_Id: string;
  Menu_Parent_Name: string;
  Menu_URL: string;
  Module_Id: string;
  Order_Id: number;
  //Status_Id:number;
  Module_Name: string;
  TotalCount: number;
  constructor() {
    super();
    this.Menu_Id = "";
    this.Menu_Name = '';
    this.Menu_Parent_Id = "";
    this.Menu_Parent_Name = '';
    this.Menu_URL = '';
    this.Module_Id = "";
    this.Order_Id = 0;
    this.Module_Name = '';
    this.TotalCount = 0;
    this.EntityMetaData = [

      { FieldName: 'Menu_Name', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Name is required' }, 
      { FieldName: 'Menu_URL', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'URL is required' },
      { FieldName: 'Module_Id', FieldType: FieldType.Key, IsMandatory: true, ValidationMessage: 'Module is required' },
      { FieldName: 'Order_Id', FieldType: FieldType.Key, IsMandatory: true, ValidationMessage: 'Order is required' },
    ];
  }
}
